import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f03de61e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=f03de61e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03de61e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f03de61e')) {
      api.createRecord('f03de61e', component.options)
    } else {
      api.reload('f03de61e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f03de61e&scoped=true&", function () {
      api.rerender('f03de61e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JThRCuEB0fcF/JS/comp/SearchFilterTokens.vue"
export default component.exports